(function () {
    'use strict';

    angular.module("imApp").factory("batchDelReceiveLineService", ['$ihttp', function ($ihttp) {
        let service = {
            getInfo: function (parms) {
                return $ihttp.post({
                    method: 1596,
                    parameters: parms || {}
                });
            },
            deleteItem: function (info) {
                return $ihttp.post({
                    method: 1597,
                    parameters: info
                });
            }
        };

        return service;
    }]);
})();
